var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['bg-image-slides', _vm.fadeClass]},[_c('CMSImage',{staticClass:"bg-image outgoing",attrs:{"image":_vm.currentImage}}),_c('CMSImage',{staticClass:"bg-image incoming",attrs:{"image":_vm.nextImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }